import { matchPath } from 'react-router-dom';
import { Page } from 'src/routes';

export function getActiveHref() {
  const path = window.location.pathname + '/';
  if (path.includes('publisher')) return '/publisher/tables'; // Setting an exception as the publisher route is compound.
  return path.substring(0, path.indexOf('/', 1));
}

export function isHomePage() {
  return getActiveHref() == '/';
}

export function shouldRedirectPage(path): boolean {
  const shouldRedirect =
    // data detail
    matchPath(path, Page.DATASET_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_DATASET_DETAILS) ||
    matchPath(path, Page.DATABASE_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_DATABASE_DETAILS) ||
    matchPath(path, Page.CATALOG_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_CATALOG_DETAILS) ||
    matchPath(path, Page.SCHEMA_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_SCHEMA_DETAILS) ||
    matchPath(path, Page.REDSHIFT_CATALOG_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_REDSHIFT_CATALOG_DETAILS) ||
    matchPath(path, Page.REDSHIFT_DATABASE_DETAILS) ||
    matchPath(path, Page.DEPRECATED_WKS_REDSHIFT_DATABASE_DETAILS) ||
    // group/workspace detail
    matchPath(path, Page.WORKSPACE_DETAIL) ||
    // group/workspace detail
    matchPath(path, Page.GROUPS) ||
    // access requests
    matchPath(path, Page.REQUESTS) ||
    matchPath(path, Page.WORKSPACE_MY_REQUESTS) ||
    // data permissions
    matchPath(path, Page.DATASETSHARE_DETAILS) ||
    matchPath(path, Page.LF_PERMISSION_DETAIL) ||
    matchPath(path, Page.PUBLISHED_PERMISSION_DETAIL) ||
    matchPath(path, Page.BASELINE_DATA_ACCESS_PERMISSION) ||
    matchPath(path, Page.BASELINE_HAMMERSTONE_GROUPS) ||
    matchPath(path, Page.BASELINE_OWNER) ||
    matchPath(path, Page.BASELINE_OWNER_WITH_ACCOUNT_ID);

  return !!shouldRedirect;
}

export function isCommonPath(path) {
  return (
    path.startsWith('/search') ||
    path.startsWith('/templates') ||
    path.startsWith('/eventsubscriptions') ||
    path.startsWith('/metadataForms') ||
    path.startsWith('/glossaries') ||
    path.startsWith('/governance-tags') ||
    path.startsWith('/advisories') ||
    path.startsWith('/datazone') ||
    path.startsWith('/workflow') ||
    path.startsWith('/datasets') ||
    path.startsWith('/databases') ||
    path.startsWith('/catalogs') ||
    path.startsWith('/groups') ||
    path.startsWith('/advisories') ||
    path.startsWith('/baseline') ||
    path.startsWith('/reports') ||
    path.startsWith('/requests') ||
    path.startsWith('/request-context')
  );
}

export function isWorkspacePath(path) {
  const isWksPath =
    isCommonPath(path) ||
    path.startsWith('/tags') ||
    path.startsWith('/notif') ||
    path.startsWith('/advisories') ||
    path.startsWith('/current-workspace/wks') ||
    path.startsWith('/fineGrainAccessPolicies') ||
    path.startsWith('/workspace');
  /** above handles the below paths
   path.startsWith('/workspaces-datasets') ||
   path.startsWith('/workspaces-databases') ||
   path.startsWith('/workspaces-catalogs') ||
   path.startsWith('/workspaces-glue-register') ||
   path.startsWith('/workspaces-redshift-register') ||
   path.startsWith('/workspaces-permission') ||
   path.startsWith('/workspaceaccess') ||
   path.startsWith('/workspaces-requests')
   **/
  return isWksPath;
}

export function isGroupLevelPath(path) {
  const isGrpPath =
    isCommonPath(path) ||
    !isWorkspacePath(path) ||
    path.startsWith('/current-workspace') ||
    path.startsWith('/mydatasets') ||
    path.startsWith('/metric') ||
    path.startsWith('/reporting') ||
    path.startsWith('/publish') ||
    path.startsWith('/resourcegroups') ||
    path.startsWith('/bootstrapactions');
  return isGrpPath;
}
